import React from 'react';
import { DecisionTreeQuestion } from '../../../../types';
import { UserStepAnswer } from '../../utils/types';
import { QuestionCounter, FinalQuestionTitle } from './styles';
import { ClientBubble } from '../ClientBubble';
import { AnswerOptions } from '../AnswerOptions';
import { Col, QuestionStyle } from 'pages/new-questions/styles/common';
import { SplitLayout, ContextCard, PanelCard } from '../SplitPanelLayout/styles';

interface ResultsPhaseViewProps {
  question: DecisionTreeQuestion;
  currentReviewStep: UserStepAnswer;
}

export const ResultsPhaseView: React.FC<ResultsPhaseViewProps> = ({
  question,
  currentReviewStep,
}) => {
  if (!currentReviewStep) return null;

  const isMultipleType = currentReviewStep.stepType === 'multiple';
  const isSingleType = currentReviewStep.stepType === 'single';

  return (
    <SplitLayout>
      <ContextCard>
        <QuestionStyle dangerouslySetInnerHTML={{ __html: question.case_context || '' }} />
      </ContextCard>

      <PanelCard>
        {isMultipleType && (
          <>
            <ClientBubble message={currentReviewStep.questionText} />
            <AnswerOptions
              answers={currentReviewStep.allAnswers}
              selectedOption={currentReviewStep.selectedAnswerId}
              onOptionClick={() => {}}
              showResults={true}
            />
          </>
        )}
        {isSingleType && (
          <Col width="100%">
            <QuestionCounter>Questão Respondida</QuestionCounter>
            <FinalQuestionTitle
              dangerouslySetInnerHTML={{ __html: currentReviewStep.questionText }}
            />
            <AnswerOptions
              answers={currentReviewStep.allAnswers}
              selectedOption={currentReviewStep.selectedAnswerId}
              onOptionClick={() => {}}
              showResults={true}
            />
          </Col>
        )}
      </PanelCard>
    </SplitLayout>
  );
};
